<template>
  <Spinner v-if="$store.state.loading"></Spinner>
  <v-app v-else>
    <Header />
    <v-main v-if="event">
      <v-container class="px-4 py-0 fill-height" fluid>
        <v-row class="fill-height">
          <v-col>
            <transition name="fade">
              <router-view> </router-view>
            </transition>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-footer app color="primary" class="white--text">
      <span></span>
      <v-spacer></v-spacer>
      <span
        >{{ $appTitle }} {{ $appVersion }} &copy;
        {{ new Date().getFullYear() }}</span
      >
    </v-footer>
  </v-app>
</template>
<script>
import Header from "@/components/Admin/Header/Header.vue";
import Spinner from "@/components/Elements/Spinner.vue";
import { mapState } from "vuex";
export default {
  components: {
    Header,
    Spinner
  },
  data: () => {
    return {};
  },

  computed: {
    ...mapState({
      event: (state) => state.events.event
    })
  },

  sockets: {
    onlineUsers(data) {
      this.$store.commit("SET_ONLINE_USERS", data);
    }
  },

  async created() {
    await this.$store.dispatch("initializeApp");
  }
};
</script>
<style>
@media (min-width: 1904px) {
  .container {
    max-width: 1264px;
  }
}
.v-navigation-drawer {
  z-index: 999 !important;
}
</style>
